<div class="top-button-container">
    <p-button label="Back" routerLink="/management/constant-contact-campaign"></p-button>
    <p-button label="Download" (click)="downloadHtml()"></p-button>
</div>
<div [innerHtml]="htmlContent" #contentContainer></div>